import React from "react";
import "./Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullhorn,
  faCode,
  faMagnifyingGlassChart,
  faCommentsDollar,
  faChartLine,
  faHandshake,
  faRobot,
  faPalette,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: "web-dev",
      icon: faCode,
      title: "Website & Landing Pages",
      description:
        "Fast, premium websites built to convert — performance, UX, SEO basics, and clean UI.",
      tags: ["Speed", "CRO", "Mobile"],
    },
    {
      id: "seo",
      icon: faMagnifyingGlassChart,
      title: "SEO That Brings Buyers",
      description:
        "Technical SEO + content strategy to rank for intent keywords and grow predictable leads.",
      tags: ["Local", "Content", "Technical"],
    },
    {
      id: "ads",
      icon: faCommentsDollar,
      title: "Google / Meta Ads",
      description:
        "Campaign setup, creative testing, and conversion tracking focused on ROAS and lead quality.",
      tags: ["ROAS", "Leads", "Scale"],
    },
    {
      id: "branding",
      icon: faPalette,
      title: "Brand & UI Direction",
      description:
        "Positioning + design system so your brand looks premium and your pages feel trustworthy.",
      tags: ["Identity", "UI Kit", "Trust"],
    },
    {
      id: "automation",
      icon: faRobot,
      title: "Automation & CRM Setup",
      description:
        "Lead capture, WhatsApp/email follow-ups, CRM pipelines, and smart nurture flows.",
      tags: ["WhatsApp", "CRM", "Retention"],
    },
    {
      id: "analytics",
      icon: faChartLine,
      title: "Tracking & Dashboards",
      description:
        "GA4, pixels, events, and KPI dashboards so you know what’s working (and what isn’t).",
      tags: ["GA4", "Pixels", "KPIs"],
    },
    {
      id: "launches",
      icon: faBullhorn,
      title: "Launch & Offer Strategy",
      description:
        "Pre-launch pages, funnels, creatives, and messaging that creates demand and momentum.",
      tags: ["Funnels", "Offer", "Hype"],
    },
    {
      id: "consulting",
      icon: faHandshake,
      title: "Growth Consulting",
      description:
        "Founder-level roadmap: audits, priorities, execution plan, and team guidance.",
      tags: ["Audit", "Roadmap", "Execution"],
    },
  ];

  return (
    <section className="srvX">
      <div className="srvX__wrap">
        {/* Header */}
        <div className="srvX__head">
          <span className="srvX__badge">Services</span>

          <h2 className="srvX__title">
            A complete system to <span>get attention</span>,{" "}
            <span>win trust</span> & <span>increase conversions</span>
          </h2>

          <p className="srvX__sub">
            Not “random tasks”. We combine strategy + execution so your website,
            ads, and SEO work together — with tracking to prove results.
          </p>
        </div>

        {/* Grid */}
        <div className="srvX__grid">
          {services.map((s) => (
            <div
              key={s.id}
              className="srvX__card"
              onClick={() => navigate(`/services/${s.id}`)}
              role="button"
              tabIndex={0}
            >
              <div className="srvX__cardTop">
                <div className="srvX__icon">
                  <FontAwesomeIcon icon={s.icon} />
                </div>

                <div className="srvX__tags">
                  {s.tags.map((t) => (
                    <span key={t} className="tag">
                      {t}
                    </span>
                  ))}
                </div>
              </div>

              <h3 className="srvX__cardTitle">{s.title}</h3>
              <p className="srvX__cardDesc">{s.description}</p>

              <div className="srvX__more">
                <span>Explore</span>
                <FontAwesomeIcon icon={faArrowRight} />
              </div>

              <div className="srvX__shine" aria-hidden="true" />
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="srvX__cta">
          <div className="ctaText">
            <h4>Confused what to start with?</h4>
            <p>
              We’ll review your website + marketing and share a prioritized
              action plan.
            </p>
          </div>

          <button className="ctaBtn" onClick={() => navigate("/contact")}>
            Get Free Audit <FontAwesomeIcon icon={faArrowRight} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;